import React from 'react';
import RecordsByClassSection from './RecordsByClassSection';

const FeeRecords = ({ 
  classes, 
  students, 
  feeRecords, 
  loading, 
  expandedClasses, 
  setExpandedClasses, 
  filters, 
  setFilters, 
  formatCurrency, 
  getCategoryStatus, 
  onAssignStructure, 
  onExpandClass 
}) => {
  return (
    <RecordsByClassSection
      classes={classes}
      students={students}
      feeRecords={feeRecords}
      loading={loading}
      expandedClasses={expandedClasses}
      setExpandedClasses={setExpandedClasses}
      filters={filters}
      setFilters={setFilters}
      formatCurrency={formatCurrency}
      getCategoryStatus={getCategoryStatus}
      onAssignStructure={onAssignStructure}
      onExpandClass={onExpandClass}
    />
  );
};

export default FeeRecords;
